const baseUrl = import.meta.env.VITE_FRONTEND_URL;

const routes = {
    article: `${baseUrl}/magazine`,
    brand: `${baseUrl}/markak`,
    ingredient: `${baseUrl}/osszetevok`,
    product: `${baseUrl}/kremek`,
    productOffer: `${baseUrl}/elado`,
    testIt: `${baseUrl}/test-it`,
    user: `${baseUrl}/profil`,
};

export default routes;
